import { OptionDefinition } from 'src/common/types/OptionDefinition';

export const SCENARIO_OPTIONS: OptionDefinition[] = [
  {label: 'Actuals', value: 'Actuals'},
  {label: 'R&O - Current', value: 'Planning'},
];
